import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { useStyles } from "@/hooks/useStyles.ts";
import { AbsenceMessageBody } from "@/pages/account/AbsenceMessage/AbsenceMessageBody.tsx";
import { Card } from "@/uiKit/atoms/Card.tsx";
import { CardContent } from "@/uiKit/atoms/CardContent.tsx";
import { CardHeader } from "@/uiKit/atoms/CardHeader.tsx";

export const AbsenceMessageCard = () => {
  const { t } = useTranslation();
  const styles = useStyles(makeStyles);

  return (
    <Card id="absence-message-card" className={styles.container}>
      <CardHeader id="absence-message-title" title={t("pages.account.absenceMessage.title")} />
      <CardContent>
        <AbsenceMessageBody />
      </CardContent>
    </Card>
  );
};

const makeStyles = () => ({
  container: css``,
});
